var _defs, _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisibilityHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visibility-hide_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".visibility-hide_svg__du{fill:url(#visibility-hide_svg__ds)}.visibility-hide_svg__dv{fill:#272727}.visibility-hide_svg__dw{fill:url(#visibility-hide_svg__dt)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visibility-hide_svg__ds",
    x1: 213.58,
    y1: 196.49,
    x2: 286.36,
    y2: 196.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visibility-hide_svg__dt",
    x1: 142.95,
    y1: 216.72,
    x2: 260.13,
    y2: 216.72,
    xlinkHref: "#visibility-hide_svg__ds"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "visibility-hide_svg__dv",
    d: "m264.79,277.7c-16.15,4.52-32.9,6.8-50.11,6.8-30.38,0-59.34-7.09-86.07-21.07-22.87-11.96-43.34-28.9-59.46-49.14,16.14-20.25,36.61-37.18,59.47-49.14,18.71-9.79,38.52-16.19,59.14-19.15l-12.96-22.15c-19.98,3.86-39.37,10.56-57.35,19.97-28.81,15.07-54.11,37.01-73.18,63.43-1.77,2.46-2.51,5.41-2.22,8.28l-1.3.93,7.02,9.74.07-.05c18.59,24.27,42.54,44.46,69.59,58.62,29.78,15.58,63.4,23.82,97.23,23.81h0c21.25,0,42.41-3.25,62.59-9.53l-12.48-21.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "visibility-hide_svg__dv",
    d: "m385.03,207.24c-19.07-26.42-44.37-48.35-73.17-63.43-29.77-15.58-63.38-23.82-97.19-23.81h0c-4.68,0-9.36.17-14.02.49l13.8,23.59c.08,0,.15,0,.23,0,30.37,0,59.31,7.09,86.03,21.07,22.86,11.96,43.34,28.89,59.47,49.14-16.12,20.24-36.59,37.18-59.45,49.14-4.24,2.22-8.55,4.25-12.9,6.12l12.24,20.92c4-1.78,7.95-3.68,11.83-5.71,28.8-15.07,54.1-37.01,73.15-63.43,3.04-4.21,3.04-9.87,0-14.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "visibility-hide_svg__du",
    d: "m228.92,168.83c7.25,2.27,13.89,6.26,19.41,11.77,8.99,9,13.95,20.96,13.95,33.68,0,3.35-.35,6.64-1.02,9.84l15.36,26.27c6.34-10.84,9.74-23.21,9.74-36.11,0-19.16-7.46-37.17-21-50.7-13.53-13.54-31.54-21-50.71-21-.36,0-.71.02-1.06.03l15.34,26.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "visibility-hide_svg__dw",
    d: "m247.73,248.54c-8.93,8.62-20.64,13.37-33.07,13.38-12.72,0-24.68-4.96-33.68-13.95-8.99-9-13.95-20.96-13.95-33.68,0-12.72,4.96-24.68,13.95-33.68,5.68-5.68,12.54-9.74,20.03-11.97l-12.39-21.19c-9.14,3.56-17.52,8.99-24.66,16.13-13.55,13.53-21.01,31.54-21,50.7,0,19.16,7.46,37.17,21,50.7,13.53,13.54,31.54,21,50.7,21h.01c16.78,0,32.68-5.73,45.46-16.25l-12.4-21.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "visibility-hide_svg__dv",
    x: 203,
    y: 23.85,
    width: 24,
    height: 382.29,
    transform: "translate(-79.13 137.95) rotate(-30.32)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityHide);
export default __webpack_public_path__ + "static/media/visibility-hide.9c34a48ff4d2a8ca1aa3b2635dc23029.svg";
export { ForwardRef as ReactComponent };